module.exports = __webpack_public_path__ + "img/img-icon.b082b035.svg";